module.exports = __webpack_public_path__ + "static/media/literacy mission_fishermen.b8d9b27d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/literacy mission_fishermen.gif
// module id = 365
// module chunks = 0